import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/envs/environnement';

/**
 * Notifications en temps reel via websocket natif (remplace le setInterval de
 * polling qui existait dans app.topbar.component.ts). Le token JWT est passe
 * en parametre de requete a la connexion : un WebSocket natif ne permet pas
 * d'ajouter un en-tete Authorization comme HttpClient (voir
 * JwtHandshakeInterceptor cote backend, qui verifie ce token une seule fois
 * a la connexion).
 */
@Injectable({
    providedIn: 'root'
})
export class NotificationSocketService implements OnDestroy {
    notification$ = new Subject<any>();

    private socket?: WebSocket;
    private reconnectTimer?: any;
    // Coupe volontairement la reconnexion (ex: apres logout()) : sans ce
    // drapeau, onclose relancerait une connexion avec un token qui n'existe
    // plus.
    private arreteVolontairement = false;

    connect(): void {
        const token = sessionStorage.getItem('token');
        if (!token) {
            return;
        }
        this.arreteVolontairement = false;

        // environment.baseUrl est du type "http(s)://host:port/api" : on ne
        // change que le schema, le endpoint /ws/notifications est enregistre
        // sous le meme context-path /api cote serveur.
        const wsUrl = environment.baseUrl.replace(/^http/, 'ws')
            + '/ws/notifications?token=' + encodeURIComponent(token);

        try {
            this.socket = new WebSocket(wsUrl);
        } catch {
            this.planifierReconnexion();
            return;
        }

        this.socket.onmessage = (event) => {
            try {
                this.notification$.next(JSON.parse(event.data));
            } catch {
                // Message illisible : ignore plutot que de casser le flux.
            }
        };

        this.socket.onclose = () => {
            if (!this.arreteVolontairement) {
                this.planifierReconnexion();
            }
        };

        this.socket.onerror = () => {
            this.socket?.close();
        };
    }

    disconnect(): void {
        this.arreteVolontairement = true;
        clearTimeout(this.reconnectTimer);
        this.socket?.close();
        this.socket = undefined;
    }

    private planifierReconnexion(): void {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = setTimeout(() => this.connect(), 5000);
    }

    ngOnDestroy(): void {
        this.disconnect();
    }
}
